window.Notifications = {};
Notifications.OneSignal = function () {
  return {
    getTags: function () {
      return new Promise((resolve, reject) => {
        OneSignal.push(() => {
          OneSignal.getTags(function (tags) {
            resolve(tags);
          });
        })
      });
    },
    isPushNotificationsSupported: function () {
      return new Promise((resolve, reject) => {
        OneSignal.push(() => {
          var isSupported = OneSignal.isPushNotificationsSupported()
          resolve(isSupported)
        })
      })
    },
    isPushNotificationsEnabled: function () {
      return new Promise((resolve, reject) => {
        OneSignal.push(() => {
          OneSignal.isPushNotificationsEnabled(isEnabled => resolve(isEnabled))
        })
      })
    },
    onPermissionChanged: function (callback) {
      OneSignal.push(() => {
        OneSignal.on('notificationPermissionChange', (permissionChange) => {
          console.log("Permissions changed: " + permissionChange.to);
          var isEnabled = permissionChange.to === 'granted'
          if (callback && typeof callback === "function")
            callback(isEnabled)
        })
      })
    },
    verifyPermision: function () {
      return new Promise((resolve, reject) => {
        OneSignal.push(() => {
          OneSignal.getNotificationPermission(permission => {
            switch (permission) {
              case "granted":
                console.log("Permission already granted");
                resolve();
                break;
              case "default":
                console.log("Requesting permission: showing prompt");
                OneSignal.registerForPushNotifications();
                reject();
                break;
              default:
                console.log('Permission denied: User action required')
                reject('DENIED');
                break;
            }
          })
        })
      })
    },
    sendTag: function (key, value) {
      return new Promise((resolve, reject) => {
        OneSignal.push(() => {
          OneSignal.getNotificationPermission(permission => {
            OneSignal.sendTag(key, value);
            console.log("Tag sent: [" + key + ", " + value + "]");

            switch (permission) {
              case "granted":
                console.log("Permission already granted");
                resolve();
                break;
              case "default":
                console.log("Requesting permission: showing prompt");
                OneSignal.registerForPushNotifications();
                break;
              default:
                console.log('Permission denied: User action required')
                reject('DENIED');
                break;
            }
          })
        })
      })
    },
    deleteTag: function (key) {
      return new Promise((resolve, reject) => {
        OneSignal.push(() => {
          OneSignal.deleteTag(key);
          console.log('Tag deleted - ' + key);
          resolve();
        })
      })
    },
    sendTags: function (tags) {
      return new Promise((resolve, reject) => {
        OneSignal.push(() => {
          OneSignal.sendTags(tags)
          resolve();
        })
      })
    }
  }
};
Notifications.Calendar = function (notification) {
  const tagPrefix = "CALENDAR_";
  var currentTags = {};

  const processTags = (tags) => {
    var calendarKeys = Object.keys(tags).filter(t => t.startsWith(tagPrefix))
    var result = calendarKeys.map(x => x.replace(tagPrefix, "").toLowerCase())
    return result;
  };

  this.onPermissionChanged = () => notification.onPermissionChanged();
  this.isPushNotificationsEnabled = () => notification.isPushNotificationsEnabled();
  this.isPushNotificationsSupported = () => notification.isPushNotificationsSupported();

  this.verifyPermision = function () {
    return new Promise((resolve, reject) => {
      notification.verifyPermision()
        .then(() => resolve())
        .catch(err => {
          reject(err);
        })
    });
  };
  this.getSubscriptions = () => {
    return new Promise((resolve, reject) => {
      if (Object.keys(currentTags).length > 0) {
        var calendarTags = processTags(currentTags);
        return resolve(calendarTags);
      }
      else {
        notification.getTags()
          .then(tags => {
            if (!tags) {
              currentTags = {};
              return resolve([]);
            }

            currentTags = tags;
            var calendarTags = processTags(tags);
            console.log('Tags received: ' + JSON.stringify(calendarTags));
            resolve(calendarTags);
          })
          .catch(err => reject(err))
      }
    })
  };
  this.subscribe = function (eventId) {
    return new Promise((resolve, reject) => {
      var tag = (tagPrefix + eventId).toUpperCase();
      notification.sendTag(tag, "1")
        .then(() => {
          currentTags[tag] = "1"
          const newTags = processTags(currentTags)

          console.log('Subscribed to event ' + eventId)

          this.verifyPermision()
            .then(() => resolve(newTags))
            .catch(err => {
              if (err === 'DENIED')
                console.log('User should active browser notifications manually (eventId: ' + eventId + ')')

              reject(err);
            });

        })
        .catch(err => {
          if (err === 'DENIED')
            console.log('User should active onesignal notifications manually (eventId: ' + eventId + ')')

          reject(err);
        })
    })
  };
  this.unsubscribe = (eventId) => {
    return new Promise((resolve, reject) => {
      var tag = (tagPrefix + eventId).toUpperCase();
      notification.deleteTag(tag)
        .then(() => {
          delete currentTags[tag]
          const newTags = processTags(currentTags)

          console.log('Unsubscribed to event ' + eventId)

          resolve(newTags)

        })

        .catch(err => {
          reject(err);
          console.error(err);
        })
    })
  }
};


var notificationCalendar;

export const calendarNotificationHelper = () => {
  return new Promise(function (resolve, reject) {
    if (!notificationCalendar)
      notificationCalendar = new Notifications.Calendar(new Notifications.OneSignal());
    resolve(notificationCalendar);
  });
}
